import { render, staticRenderFns } from "./QrCodeReader.vue?vue&type=template&id=b70e012a&scoped=true"
import script from "./QrCodeReader.vue?vue&type=script&lang=js"
export * from "./QrCodeReader.vue?vue&type=script&lang=js"
import style0 from "./QrCodeReader.vue?vue&type=style&index=0&id=b70e012a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70e012a",
  null
  
)

export default component.exports